export const MAIN_TOOLBAR_HEIGHT = 48;
export const LIST_HEADER_HEIGHT = 41;
export const APP_BAR_HEIGHT = MAIN_TOOLBAR_HEIGHT + LIST_HEADER_HEIGHT;

export const SCROLLABLE_VIEW = 'scrollable-view';

export const WAVY_NAVY = 'rgb(4, 41, 76)';
export const GROOVEY_BLUEY = 'rgb(41, 213, 213)';
